import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import DropdownOption from './DropdownOption';
import { translateResourceString } from '../../util/translationUtility';

let sortOptions = [];

class SortByDropdown extends React.Component {
    constructor(props) {
        super(props)

        this.toggle = this.toggle.bind(this);
        this.state = {
            dropdownOpen: false
        };
    }

    toggle() {
        this.setState(prevState => ({
            dropdownOpen: !prevState.dropdownOpen
        }));
    }

    render() {
        const { CurrentSortBy, onCurrentSortByChange, sortOptions } = this.props;

        // Need to go through array and find when it matches
        const found = sortOptions.find(option => {
            return option.value === CurrentSortBy;
        });

        const selectedSort = found ? found : sortOptions[0];
        const title = <span><span className="hidden-xxs">{translateResourceString("/SearchApp/SortBy")} </span>{selectedSort.displayName} <i className="ml-1 fa fa-chevron-down" /></span>;
        return (
            <Dropdown
                isOpen={this.state.dropdownOpen}
                toggle={this.toggle}
                id={`sort-by-dropdown`}
            >
                <DropdownToggle color="blue" className="no-arrow">
                    {title}
                </DropdownToggle>
                <DropdownMenu>
                    {sortOptions.map((option, i) => {
                        if(option !== selectedSort){
                            return (
                                <DropdownItem
                                    key={i}
                                    onClick={() => onCurrentSortByChange(option.value)}
                                >
                                    {option.displayName}
                                </DropdownItem>
                            );
                        }
                    })

                    }
                </DropdownMenu>
            </Dropdown>
        );
    }
};

SortByDropdown.propTypes = {
    CurrentSortBy: PropTypes.string,
    onCurrentSortByChange: PropTypes.func
};

export default SortByDropdown;
